<div class="info-row">
  <div class="info-row_label">
    <i *ngIf="icon" [class]="icon"></i>
    <img *ngIf="labelIconLink" [src]="labelIconLink" alt="" />
    <span>{{ label }}</span>
  </div>
  <ng-container *ngIf="!isLoading; else loading">
    <div class="info-row_value">
      {{
        value && (value + "").trim() ? (value + "").trim() : noValuePlaceholder
      }}
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <app-skeleton-loader height="20px" width="100%"></app-skeleton-loader>
</ng-template>
